(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["festival-offer-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  const IST_OFFSET_MS = 330 * 60 * 1000;
  const DAY_MS = 24 * 60 * 60 * 1000;

  function indiaMidnight(dateValue) {
    const match = /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.exec(dateValue || '');
    if (!match) return null;
    const year = Number(match[1]);
    const month = Number(match[2]) - 1;
    const day = Number(match[3]);
    const utc = Date.UTC(year, month, day) - IST_OFFSET_MS;
    const check = new Date(utc + IST_OFFSET_MS);
    if (check.getUTCFullYear() !== year || check.getUTCMonth() !== month || check.getUTCDate() !== day) return null;
    return utc;
  }

  function initialize(root) {
    const sections = [];
    if (root.matches && root.matches('[data-festival-offer]')) sections.push(root);
    if (root.querySelectorAll) sections.push(...root.querySelectorAll('[data-festival-offer]'));

    sections.forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const daysNode = section.querySelector('[data-days]');
      const hoursNode = section.querySelector('[data-hours]');
      const minutesNode = section.querySelector('[data-minutes]');
      const secondsNode = section.querySelector('[data-seconds]');
      const announcement = section.querySelector('[data-countdown-announcement]');
      const previewNote = section.querySelector('.fo__preview-note');
      const preview = section.dataset.preview === 'true';
      const navStart = indiaMidnight(section.dataset.navStart);
      const navEndDate = indiaMidnight(section.dataset.navEnd);
      const diwaliEndDate = indiaMidnight(section.dataset.diwaliEnd);
      const delayDays = Math.max(0, Number(section.dataset.diwaliDelay) || 0);
      const navEnd = navEndDate === null ? null : navEndDate + DAY_MS;
      const diwaliStart = navEnd === null ? null : navEnd + delayDays * DAY_MS;
      const diwaliEnd = diwaliEndDate === null ? null : diwaliEndDate + DAY_MS;
      const closeButton = section.querySelector('.fo__close');
      const dismissKey = 'festival-offer-dismissed-' + section.dataset.sectionId;
      let timerTarget = null;
      let shownPhase = 'inactive';
      let announceAt = 0;

      function setPhase(phase, target, isPreview) {
        if (shownPhase !== phase) {
          shownPhase = phase;
          section.dataset.currentPhase = phase;
        }
        section.dataset.previewing = isPreview ? 'true' : 'false';
        timerTarget = target;
        if (previewNote) previewNote.hidden = !isPreview;
      }

      function choosePhase(now) {
        if (navStart !== null && navEnd !== null && navStart < navEnd && now >= navStart && now < navEnd) {
          return { phase: 'navratri', end: navEnd };
        }
        if (diwaliStart !== null && diwaliEnd !== null && diwaliStart < diwaliEnd && now >= diwaliStart && now < diwaliEnd) {
          return { phase: 'diwali', end: diwaliEnd };
        }
        return null;
      }

      function update() {
        if (!section.isConnected) return;
        if (window.sessionStorage.getItem(dismissKey) === 'true' && !preview) {
          section.hidden = true;
          return;
        }

        const now = Date.now();
        const active = choosePhase(now);
        if (active) {
          section.hidden = false;
          setPhase(active.phase, active.end, false);
        } else if (preview) {
          section.hidden = false;
          setPhase('navratri', now + 12 * DAY_MS + 8 * 60 * 60 * 1000 + 6 * 60 * 1000 + 11000, true);
        } else {
          setPhase('inactive', null, false);
          section.hidden = false;
          return;
        }

        const remaining = Math.max(0, timerTarget - now);
        const days = Math.floor(remaining / DAY_MS);
        const hours = Math.floor((remaining % DAY_MS) / (60 * 60 * 1000));
        const minutes = Math.floor((remaining % (60 * 60 * 1000)) / (60 * 1000));
        const seconds = Math.floor((remaining % (60 * 1000)) / 1000);
        daysNode.textContent = String(days).padStart(2, '0');
        hoursNode.textContent = String(hours).padStart(2, '0');
        minutesNode.textContent = String(minutes).padStart(2, '0');
        secondsNode.textContent = String(seconds).padStart(2, '0');

        if (announcement && now - announceAt > 60000) {
          announcement.textContent = days + ' days, ' + hours + ' hours, ' + minutes + ' minutes remaining';
          announceAt = now;
        }
      }

      if (closeButton) {
        closeButton.addEventListener('click', function () {
          if (!preview) window.sessionStorage.setItem(dismissKey, 'true');
          section.hidden = true;
        });
      }

      update();
      section._festivalOfferInterval = window.setInterval(update, 1000);
    });
  }

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target.querySelectorAll) return;
    event.target.querySelectorAll('[data-festival-offer]').forEach(function (section) {
      if (section._festivalOfferInterval) window.clearInterval(section._festivalOfferInterval);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kaori-values"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kaori-values')) {
    class KaoriValues extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-kv-item]'));
        this.slides = Array.from(this.querySelectorAll('[data-kv-slide]'));
        if (!this.items.length) return;

        this.index = Math.max(0, this.items.findIndex((el) => el.classList.contains('is-active')));
        this.autoplay = this.dataset.autoplay === 'true' && this.items.length > 1;
        this.hoverTrigger = this.dataset.hover === 'true';
        this.pauseOnHover = this.dataset.pauseHover === 'true';
        this.state = { hover: false, offscreen: false, editor: false };
        this.hoverMQ = window.matchMedia('(hover: hover) and (min-width: 990px)');

        // Autoplay advances when the active progress bar finishes
        this.onAnimationEnd = (e) => {
          if (!e.target.hasAttribute('data-kv-progress')) return;
          if (e.target.closest('[data-kv-item]') !== this.items[this.index]) return;
          this.go((this.index + 1) % this.items.length);
        };
        this.addEventListener('animationend', this.onAnimationEnd);

        this.items.forEach((item, i) => {
          item.addEventListener('click', () => this.go(i));
          item.addEventListener('keydown', (e) => this.onKey(e, i));
          item.addEventListener('mouseenter', () => {
            if (this.hoverTrigger && this.hoverMQ.matches && i !== this.index) this.go(i);
          });
        });

        // Pause on hover (real pointer devices only, so touch never gets stuck paused)
        this.addEventListener('mouseenter', () => {
          if (!this.pauseOnHover || !this.hoverMQ.matches) return;
          this.state.hover = true;
          this.sync();
        });
        this.addEventListener('mouseleave', () => {
          this.state.hover = false;
          this.sync();
        });

        // Pause while off screen
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              this.state.offscreen = !entries[0].isIntersecting;
              this.sync();
            },
            { threshold: 0.15 }
          );
          this.observer.observe(this);
        }

        // Theme editor: selecting a block shows its image
        this.onBlockSelect = (e) => {
          if (e.detail.sectionId !== this.dataset.sectionId) return;
          const i = this.items.findIndex((el) => el.dataset.blockId === e.detail.blockId);
          if (i < 0) return;
          this.state.editor = true;
          this.go(i);
        };
        this.onBlockDeselect = (e) => {
          if (e.detail.sectionId !== this.dataset.sectionId) return;
          this.state.editor = false;
          this.sync();
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.go(this.index);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      go(i, focus = false) {
        if (i < 0 || i >= this.items.length) return;
        this.index = i;

        this.items.forEach((item, n) => {
          const on = n === i;
          item.classList.toggle('is-active', on);
          item.setAttribute('aria-selected', on ? 'true' : 'false');
          item.tabIndex = on ? 0 : -1;
          const bar = item.querySelector('[data-kv-progress]');
          if (bar) bar.classList.remove('is-running');
        });

        this.slides.forEach((slide, n) => {
          slide.classList.toggle('is-active', n === i);
          if (n === i) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });

        if (focus) this.items[i].focus();

        if (this.autoplay) {
          const bar = this.items[i].querySelector('[data-kv-progress]');
          if (bar) {
            void bar.offsetWidth; // restart animation
            bar.classList.add('is-running');
          }
        }
        this.sync();
      }

      sync() {
        const running = this.autoplay && !this.state.hover && !this.state.offscreen && !this.state.editor;
        this.style.setProperty('--kv-play', running ? 'running' : 'paused');
      }

      onKey(e, i) {
        const last = this.items.length - 1;
        let target;
        switch (e.key) {
          case 'ArrowDown':
          case 'ArrowRight':
            target = i === last ? 0 : i + 1;
            break;
          case 'ArrowUp':
          case 'ArrowLeft':
            target = i === 0 ? last : i - 1;
            break;
          case 'Home':
            target = 0;
            break;
          case 'End':
            target = last;
            break;
          case 'Enter':
          case ' ':
            target = i;
            break;
          default:
            return;
        }
        e.preventDefault();
        this.go(target, true);
      }
    }
    customElements.define('kaori-values', KaoriValues);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
